module Eseebase {

    export class TranslationData {
        public translation: string;
        public loading: boolean;
    }

    export function TranslateFunction(textService: TextService) {
        return (input: string) => {
            return textService.translate(input);
        }
    }
    (<any>TranslateFunction).$stateful = true;
    TranslateFunction.$inject = ['TextService'];

    angular
        .module('eseebase')
        .filter('translate', TranslateFunction);
}